import { ISheetPagesModel } from '@shared/models';

export function exportToExcelUtils(sheets: ISheetPagesModel[], fileName: string) {
  // Defer loading 'xlsx' to avoid evaluating it during initial app bootstrap
  // This prevents environment detection that accesses process.* in the browser
  import('xlsx')
    .then((mod) => {
      const XLSX = (mod as any).default || mod;
      const wb = XLSX.utils.book_new();

      sheets.forEach((sheet) => {
        const ws = XLSX.utils.aoa_to_sheet(sheet.data);
        XLSX.utils.book_append_sheet(wb, ws, sheet.sheetName);
      });

      XLSX.writeFile(wb, fileName);
    })
    .catch((err) => {
      console.error('xlsx dynamic import failed', err);
    });
}
